(function() { window.GUID_73ed34d6_2af6_4160_943d_849a3c1f0c37 = { getGuid: function() { return "73ed34d6-2af6-4160-943d-849a3c1f0c37"; } }; })();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        let ChartState;
        (function (ChartState) {
            ChartState["Ready"] = "ready";
            ChartState["Loading"] = "loading";
            ChartState["Error"] = "error";
        })(ChartState || (ChartState = {}));
        class TCSRVariationChart extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.ControlId}`);
            }
            OnControlInstantiation(params) {
                console.log("TCSRVariationChart.OnControlInstantiation", params);
                this.controlId = params[0];
            }
            OnBindEvents() { }
            OnDispose() { }
            get totalVariationLabel() {
                let result = "";
                if (this.totalVariation == null || isNaN(this.totalVariation)) {
                    return result;
                }
                else if (this.totalVariation >= 0) {
                    result = `+${this.totalVariation.toFixed(2)}`;
                }
                else {
                    result = `${this.totalVariation.toFixed(2)}`;
                }
                if (result.endsWith(".00")) {
                    result = result.replace(".00", "");
                }
                return result;
            }
            get lang() {
                var _a, _b;
                return ((_b = (_a = CS.CommonData === null || CS.CommonData === void 0 ? void 0 : CS.CommonData.Current) === null || _a === void 0 ? void 0 : _a.Language) !== null && _b !== void 0 ? _b : "en").toLowerCase();
            }
            /**
             *
             * @param controlId
             * @param data
             * @param withGameHistory If true, the chart will display the game history of the selected week, which is the most recent week by default.
             */
            constructor(controlId, data, itsMe, withGameHistory = true, hideTCSRVariationOnGameHistory = false) {
                super(controlId);
                this.controlId = controlId;
                this.data = data;
                this.itsMe = itsMe;
                this.withGameHistory = withGameHistory;
                this.hideTCSRVariationOnGameHistory = hideTCSRVariationOnGameHistory;
                this.chartCssClass = "tcsr-variation-chart";
                this.gameHistoryCssClass = "tcsr-variation-chart__game-history";
                this.setWeekTimeout = null;
            }
            init() {
                return __awaiter(this, void 0, void 0, function* () {
                    yield this.initialize();
                });
            }
            setWeek(timestamp) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        if (this.setWeekTimeout) {
                            clearTimeout(this.setWeekTimeout);
                        }
                        this.setWeekTimeout = setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                            this.setWeekTimeout = null;
                            this.setDatapointsToRender(timestamp);
                            this.setVariationData();
                            yield this.reRender();
                            this.Trigger(TCSRVariationChart.EventNames.Updated, {
                                jqueryEventObject: null,
                                data: { timestamp },
                            });
                        }), 1000);
                    }
                    catch (error) {
                        console.error("Error while setting week.", error);
                    }
                });
            }
            initialize() {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        this.parseData();
                        this.setDatapointsToRender();
                        this.setVariationData();
                        this.render()
                            .then(() => {
                            this.bindEvents();
                        })
                            .catch((error) => {
                            console.error(error);
                        });
                    }
                    catch (error) {
                        console.error(error);
                    }
                });
            }
            reRender() {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        this.$Control.empty();
                        yield this.render();
                    }
                    catch (error) {
                        console.error("Error while re-rendering.", error);
                    }
                });
            }
            render() {
                return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                    try {
                        this.renderChart();
                        if (this.withGameHistory) {
                            yield this.renderGameHistory();
                        }
                        return resolve();
                    }
                    catch (error) {
                        return reject(error);
                    }
                }));
            }
            renderGameHistory() {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        const label = JSRess.GameHistoryOfTheWeek;
                        const gameHistoryHTML = `
        <div class="${this.gameHistoryCssClass}">
          <div class="${this.gameHistoryCssClass}__header">
            <div class="title">
                <span class="label">${label}</span>
            </div>
            <select id="${this.controlId}-select" class="select" title="Select a week">
            </select>
          </div>
          <div class="${this.gameHistoryCssClass}__body">
          </div>
        </div>
      `;
                        this.$Control.append(gameHistoryHTML);
                        const reversedDatapoints = [...this.datapointsToRender].reverse();
                        this.setGameHistorySelectOptions(reversedDatapoints);
                        yield this.loadGameHistory(reversedDatapoints[0].timestamp, true);
                    }
                    catch (error) {
                        console.error("Error while rendering game history.", error);
                    }
                });
            }
            setGameHistorySelectOptions(reversedDatapoints) {
                try {
                    const select = this.$Control.find(`.${this.gameHistoryCssClass} .select`)[0];
                    for (let i = 0; i < reversedDatapoints.length; i++) {
                        const datapoint = reversedDatapoints[i];
                        const optionExists = select.querySelector(`option[value="${datapoint.timestamp}"]`);
                        if (optionExists) {
                            continue;
                        }
                        const option = document.createElement("option");
                        option.value = datapoint.timestamp.toString();
                        const endDate = new Date(datapoint.date);
                        //endDate.setDate(endDate.getDate() - 1);
                        const startDate = new Date(endDate);
                        startDate.setDate(startDate.getDate() - 6);
                        const sameMonth = startDate.getMonth() === endDate.getMonth();
                        const sameYear = startDate.getFullYear() === endDate.getFullYear();
                        //const startDateLabel = CS.Helper.AddSuffixToDay(
                        //  startDate,
                        //  startDate.toLocaleDateString(this.lang, {
                        //    day: "numeric",
                        //    month: "short",
                        //    year: sameYear ? undefined : "numeric",
                        //  })
                        //  );
                        const startDateLabel = CS.Helper.AddSuffixToDay(startDate, startDate.toLocaleDateString(this.lang, {
                            day: "numeric",
                            month: this.lang == "en" ? "short" : sameMonth ? undefined : "short",
                            year: sameYear ? undefined : "numeric",
                        }));
                        let endDateMonthFormat = "short";
                        let monthFormatToRemove = sameMonth && this.lang == "en" ? endDateMonthFormat : undefined;
                        const endDateLabel = CS.Helper.AddSuffixToDay(endDate, endDate.toLocaleDateString(this.lang, {
                            day: "numeric",
                            month: endDateMonthFormat,
                            year: "numeric",
                        }), monthFormatToRemove);
                        const innerText = CS.Helper.formatString(JSRess.XtoY, startDateLabel, endDateLabel);
                        option.innerText = innerText;
                        select.appendChild(option);
                    }
                }
                catch (error) {
                    console.error("Error while setting game history select options.", error);
                }
            }
            loadGameHistory(timestamp, preventScroll) {
                return __awaiter(this, void 0, void 0, function* () {
                    var _a, _b, _c, _d, _e;
                    try {
                        this.setSelectedOption(timestamp);
                        const gameHistorySectionURL = CS.Url.CSUrl("GetGamesOfTheWeekForCSRDetails");
                        if (!gameHistorySectionURL) {
                            return;
                        }
                        const select = this.$Control.find(`.${this.gameHistoryCssClass} .select`)[0];
                        if (!select) {
                            return;
                        }
                        const $gameHistoryHeader = this.$Control.find(`.${this.gameHistoryCssClass}__header`);
                        const $gameHistoryBody = this.$Control.find(`.${this.gameHistoryCssClass}__body`);
                        if (!$gameHistoryBody.length || !$gameHistoryHeader.length) {
                            return;
                        }
                        select.disabled = true;
                        $gameHistoryBody.css({
                            opacity: 0.5,
                        });
                        CS.Helper.ShowLoader({
                            id: this.gameHistoryCssClass,
                            $container: () => $gameHistoryHeader,
                            position: "append",
                            overContent: true,
                        });
                        const userId = this.itsMe
                            ? (_c = (_b = (_a = CS.CommonData) === null || _a === void 0 ? void 0 : _a.Current) === null || _b === void 0 ? void 0 : _b.UserId) !== null && _c !== void 0 ? _c : undefined
                            : undefined;
                        const entityBaseId = this.itsMe
                            ? undefined
                            : (_e = (_d = this.datapointsToRender.find((datapoint) => datapoint.timestamp === timestamp)) === null || _d === void 0 ? void 0 : _d.entityBaseId) !== null && _e !== void 0 ? _e : undefined;
                        const data = {
                            userId,
                            entityBaseId,
                            timestamp,
                            hideTCSRVariation: this.hideTCSRVariationOnGameHistory,
                        };
                        CS.Ajax.Get(gameHistorySectionURL, data, (response) => {
                            select.disabled = false;
                            if (this.gameHistoryCssClass) {
                                const $gameHistoryHeader = this.$Control.find(`.${this.gameHistoryCssClass}__header`);
                                if ($gameHistoryHeader.length) {
                                    CS.Helper.RemoveLoader({
                                        id: this.gameHistoryCssClass,
                                        $container: $gameHistoryHeader,
                                    });
                                }
                                const $gameHistoryBody = this.$Control.find(`.${this.gameHistoryCssClass}__body`);
                                if ($gameHistoryBody.length) {
                                    $gameHistoryBody.css({
                                        opacity: 1,
                                    });
                                    $gameHistoryBody.html("");
                                    $gameHistoryBody.append(response);
                                }
                            }
                            if (!preventScroll) {
                                this.scrollToGameHistory();
                            }
                        });
                    }
                    catch (error) {
                        console.error("Error while loading game history.", error);
                    }
                });
            }
            scrollToGameHistory() {
                var _a, _b, _c, _d;
                try {
                    if (!this.gameHistoryCssClass) {
                        return;
                    }
                    const $gameHistoryHeader = this.$Control.find(`.${this.gameHistoryCssClass}__header`);
                    if (!$gameHistoryHeader.length) {
                        return;
                    }
                    const $topbar = CS.DOM.$topBar;
                    let topHeight = (_a = $topbar === null || $topbar === void 0 ? void 0 : $topbar.outerHeight()) !== null && _a !== void 0 ? _a : 0;
                    const $tabmenu = $(`#csr-details-wall-tab-menu`);
                    if ($tabmenu.length) {
                        topHeight += (_b = $tabmenu === null || $tabmenu === void 0 ? void 0 : $tabmenu.outerHeight()) !== null && _b !== void 0 ? _b : 0;
                    }
                    const offset = (_d = (_c = $gameHistoryHeader.offset()) === null || _c === void 0 ? void 0 : _c.top) !== null && _d !== void 0 ? _d : 0;
                    const padding = 20;
                    const scroll = offset - topHeight - padding;
                    $("html, body").animate({
                        scrollTop: scroll,
                    }, 500);
                }
                catch (error) {
                    console.error("Error while scrolling to game history.", error);
                }
            }
            setSelectedOption(timestamp) {
                try {
                    const select = this.$Control.find(`.${this.gameHistoryCssClass} .select`)[0];
                    if (!select) {
                        return;
                    }
                    const option = select.querySelector(`option[value="${timestamp}"]`);
                    if (!option) {
                        return;
                    }
                    for (let i = 0; i < select.options.length; i++) {
                        select.options[i].selected = false;
                    }
                    option.selected = true;
                }
                catch (error) {
                    console.error("Error while setting selected option.", error);
                }
            }
            renderChart() {
                const chartHTML = `
      <div class="${this.chartCssClass}">
      </div>
    `;
                this.$Control.append(chartHTML);
                this.renderChartHeader();
                this.renderChartBody();
            }
            renderChartBody() {
                try {
                    if (!this.datapointsToRender || this.datapointsToRender.length === 0) {
                        return;
                    }
                    let html = `
          <div class="${this.chartCssClass}__body">
          `;
                    [...this.datapointsToRender].reverse().forEach((datapoint) => {
                        html += this.getDatapointHTML(datapoint);
                    });
                    html += `
          </div>
        `;
                    this.$Control.find(`.${this.chartCssClass}`).append(html);
                }
                catch (error) {
                    console.error("Error while rendering body.", error);
                }
            }
            getDatapointHTML(datapoint) {
                try {
                    const endDate = new Date(datapoint.date);
                    //endDate.setDate(endDate.getDate() - 1);
                    const startDate = new Date(endDate);
                    startDate.setDate(startDate.getDate() - 6);
                    const sameMonth = startDate.getMonth() === endDate.getMonth();
                    const sameYear = startDate.getFullYear() === endDate.getFullYear();
                    // const startDateLabel = startDate.toLocaleDateString(this.lang, {
                    //   day: "numeric",
                    //   month: sameMonth ? undefined : "short",
                    //   year: sameYear ? undefined : "numeric",
                    // });
                    // const endDateLabel = endDate.toLocaleDateString(this.lang, {
                    //   month: "short",
                    //   day: "numeric",
                    //   year: "numeric",
                    // });
                    const startDateLabel = CS.Helper.AddSuffixToDay(startDate, startDate.toLocaleDateString(this.lang, {
                        day: "numeric",
                        month: this.lang == "en" ? "short" : sameMonth ? undefined : "short",
                        year: sameYear ? undefined : "numeric",
                    }));
                    let endDateMonthFormat = "short";
                    let monthFormatToRemove = sameMonth && this.lang == "en" ? endDateMonthFormat : undefined;
                    const endDateLabel = CS.Helper.AddSuffixToDay(endDate, endDate.toLocaleDateString(this.lang, {
                        day: "numeric",
                        month: endDateMonthFormat,
                        year: "numeric",
                    }), monthFormatToRemove);
                    // const endDateLabel = CS.Helper.AddSuffixToDay(
                    //     endDate,
                    //     endDate.toLocaleDateString(this.lang, {
                    //         day: "numeric",
                    //         month: sameMonth ? "long" : "short",
                    //         year: "numeric",
                    //     }),
                    //     "long"
                    // );
                    const dateLabel = CS.Helper.formatString(JSRess.XtoY, startDateLabel, endDateLabel);
                    const gamesCountLabel = CS.Helper.formatString(JSRess.XGames, datapoint.gamesCount.toString());
                    const tcsrLabel = CS.Helper.formatString(JSRess.TCSRIsX, datapoint.value);
                    let variationLabel = datapoint.variation >= 0
                        ? `+${datapoint.variation}`
                        : `${datapoint.variation}`;
                    if (datapoint.variation === null) {
                        variationLabel = "N/A";
                    }
                    let variationLabelCssClass = "label";
                    if (datapoint.variation > 0) {
                        variationLabelCssClass += " positive";
                    }
                    else if (datapoint.variation < 0) {
                        variationLabelCssClass += " negative";
                    }
                    else {
                        variationLabelCssClass += " neutral";
                    }
                    let result = `
          <div class="datapoint hoverable" data-timestamp="${datapoint.timestamp}">
            <div class="datapoint__header">
              <div class="left">
                <div class="date">
                  <span class="label">${dateLabel}</span>
                </div>
                <div class="infos">
                  <span class="info">${gamesCountLabel},</span>
                  <span class="info"> ${tcsrLabel}</span>
                </div>
              </div>
              <div class="right">
                <div class="variation">
                  <span class="${variationLabelCssClass}">${variationLabel}</span>
                </div>
              </div>
            </div>
            <div class="datapoint__body">
              ${this.getDatapointBodyHTML(datapoint)}
            </div>
          </div>
        `;
                    return result;
                }
                catch (error) {
                    console.error("Error while getting datapoint HTML.", error);
                    return "";
                }
            }
            getDatapointBodyHTML(datapoint) {
                try {
                    const variationPercentage = (Math.abs(datapoint.variation) / this.absoluteMaximumVariation) * 100;
                    let variationCssClass = "variation";
                    if (datapoint.variation > 0) {
                        variationCssClass += " positive";
                    }
                    else if (datapoint.variation < 0) {
                        variationCssClass += " negative";
                    }
                    else {
                        variationCssClass += " neutral";
                    }
                    let style = `width: ${variationPercentage}%;`;
                    if (variationCssClass === "variation neutral") {
                        style = `width: 8px`;
                    }
                    let result = `
          <div class="${variationCssClass}" style="${style}"></div>
        `;
                    return result;
                }
                catch (error) {
                    console.error("Error while getting datapoint body HTML.", error);
                    return "";
                }
            }
            renderChartHeader() {
                try {
                    if (!this.datapointsToRender || this.datapointsToRender.length === 0) {
                        return;
                    }
                    const firstEndDate = new Date(this.datapointsToRender[0].date);
                    //firstEndDate.setDate(firstEndDate.getDate() - 1);
                    const startDate = new Date(firstEndDate);
                    startDate.setDate(startDate.getDate() - 6);
                    const endDate = new Date(this.datapointsToRender[this.datapointsToRender.length - 1].date);
                    const sameMonth = startDate.getMonth() === endDate.getMonth();
                    const sameYear = startDate.getFullYear() === endDate.getFullYear();
                    // const startDateLabel = startDate.toLocaleDateString(this.lang, {
                    //   month: "short",
                    //   day: "numeric",
                    //   year: "numeric",
                    // });
                    const startDateLabel = CS.Helper.AddSuffixToDay(startDate, startDate.toLocaleDateString(this.lang, {
                        day: "numeric",
                        month: this.lang == "en" ? "short" : sameMonth ? undefined : "short",
                        year: sameYear ? undefined : "numeric",
                    }));
                    //endDate.setDate(endDate.getDate() - 1);
                    // const endDateLabel = endDate.toLocaleDateString(this.lang, {
                    //   month: "short",
                    //   day: "numeric",
                    //   year: "numeric",
                    // });
                    let endDateMonthFormat = "short";
                    let monthFormatToRemove = sameMonth && this.lang == "en" ? endDateMonthFormat : undefined;
                    const endDateLabel = CS.Helper.AddSuffixToDay(endDate, endDate.toLocaleDateString(this.lang, {
                        day: "numeric",
                        month: endDateMonthFormat,
                        year: "numeric",
                    }), monthFormatToRemove);
                    // const endDateLabel = CS.Helper.AddSuffixToDay(
                    //   endDate,
                    //   endDate.toLocaleDateString(this.lang, {
                    //     day: "numeric",
                    //     month: sameMonth ? "long" : "short",
                    //     year: "numeric",
                    //   }),
                    //   "long"
                    // );
                    const title = JSRess.TCSRVariaiton;
                    const range = `${CS.Helper.formatString(JSRess.FromX, startDateLabel)} ${CS.Helper.formatString(JSRess.ToX, endDateLabel)}`;
                    let valueCssClass = "value";
                    if (this.totalVariation > 0) {
                        valueCssClass += " positive";
                    }
                    else if (this.totalVariation < 0) {
                        valueCssClass += " negative";
                    }
                    const subtitle = CS.Helper.formatString(JSRess.TotalOverXWeeks, this.datapointsToRender.length);
                    let html = `
          <div class="${this.chartCssClass}__header">
            <div class="title">
              <span class="label">${title}</span>
            </div>
            <div class="range">
              <span class="label">
                ${range}
              </span>
            </div>
            <div class="subtitle">
              <span class="label">${subtitle}</span>
              <span class="${valueCssClass}">${this.totalVariationLabel}</span>
            </div>
          </div>
        `;
                    this.$Control.find(`.${this.chartCssClass}`).append(html);
                }
                catch (error) {
                    console.error("Error while rendering header.", error);
                }
            }
            setVariationData() {
                try {
                    if (!this.datapointsToRender || this.datapointsToRender.length === 0) {
                        return;
                    }
                    this.totalVariation =
                        Math.round(this.datapointsToRender.reduce((acc, curr) => acc + curr.variation, 0) * 100) / 100;
                    this.minimumVariation = Math.min(...this.datapointsToRender.map((datapoint) => datapoint.variation));
                    this.maximumVariation = Math.max(...this.datapointsToRender.map((datapoint) => datapoint.variation));
                    this.absoluteMaximumVariation = Math.max(Math.abs(this.minimumVariation), Math.abs(this.maximumVariation));
                    this.absoluteMinimumVariation = Math.min(Math.abs(this.minimumVariation), Math.abs(this.maximumVariation));
                }
                catch (error) {
                    console.error("Error while setting variation data.", error);
                }
            }
            setDatapointsToRender(timestamp) {
                try {
                    const lastDatapoint = timestamp
                        ? this.datapoints.find((datapoint) => datapoint.timestamp === timestamp)
                        : this.datapoints[this.datapoints.length - 1];
                    const count = 12;
                    const indexOfLastDatapoint = this.datapoints.indexOf(lastDatapoint);
                    let indexOfFirstDatapoint = indexOfLastDatapoint - count;
                    if (indexOfFirstDatapoint < 0) {
                        indexOfFirstDatapoint = 0;
                    }
                    let datapoints = this.datapoints.slice(indexOfFirstDatapoint, indexOfLastDatapoint + 1);
                    if (datapoints.length > count) {
                        datapoints = datapoints.slice(datapoints.length - count);
                    }
                    this.datapointsToRender = datapoints;
                }
                catch (error) {
                    console.error("Error while getting datapoints to render.", error);
                    this.datapointsToRender = [];
                }
            }
            getStatName(statFieldId) {
                return statFieldId === "CompuSportRating" ? "CSR" : "T-CSR";
            }
            parseData() {
                if (this.data == null) {
                    throw new Error("Data not found.");
                }
                this.datapoints = this.data
                    .filter((statUserGraph) => {
                    return statUserGraph.StatFieldId === "TCSR";
                })
                    .map((statUserGraph, index) => {
                    const date = new Date(statUserGraph.StatDateString);
                    const timestamp = statUserGraph.StatDateTimestamp;
                    const stat = this.getStatName(statUserGraph.StatFieldId);
                    const datapoint = {
                        id: `${statUserGraph.StatFieldId}-${timestamp}`,
                        date: date,
                        timestamp: timestamp,
                        entityBaseId: statUserGraph.EntityBaseId.toString(),
                        stat: stat,
                        value: statUserGraph.Value,
                        gamesCount: statUserGraph.DisplayValue,
                        variation: statUserGraph.RankingValue === CS.Helper.IntMinValue
                            ? null
                            : statUserGraph.RankingValue,
                    };
                    return datapoint;
                })
                    .sort((a, b) => {
                    return a.timestamp - b.timestamp;
                });
            }
            bindEvents() {
                try {
                    this.$Control.offon("click.datapointclicked", ".datapoint", this.handleDatapointClick.bind(this));
                    this.$Control.offon("change.selectchanged", `.${this.gameHistoryCssClass} .select`, (event) => {
                        const $target = $(event.currentTarget);
                        const timestamp = parseInt($target.val());
                        this.loadGameHistory(timestamp, true);
                    });
                }
                catch (error) {
                    console.error("Error while binding events.", error);
                }
            }
            handleDatapointClick(event) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        const $target = $(event.currentTarget);
                        const timestamp = $target.data("timestamp");
                        this.Trigger(TCSRVariationChart.EventNames.DatapointClicked, {
                            jqueryEventObject: event,
                            data: {
                                timestamp,
                            },
                        });
                        yield this.loadGameHistory(timestamp);
                    }
                    catch (error) {
                        console.error("Error while handling datapoint click.", error);
                    }
                });
            }
        }
        Controls.TCSRVariationChart = TCSRVariationChart;
        (function (TCSRVariationChart) {
            class Events {
                static Updated(param) {
                    Controls.RegisterEvent(TCSRVariationChart, EventNames.Updated, param);
                }
                static DatapointClicked(param) {
                    Controls.RegisterEvent(TCSRVariationChart, EventNames.DatapointClicked, param);
                }
            }
            TCSRVariationChart.Events = Events;
            class EventNames {
            }
            EventNames.Updated = "updated";
            EventNames.DatapointClicked = "datapoint-clicked";
            TCSRVariationChart.EventNames = EventNames;
        })(TCSRVariationChart = Controls.TCSRVariationChart || (Controls.TCSRVariationChart = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=TCSRVariationChart.js.map
